(function(){
"use strict";

/* ================================================================
   CONFIG —— 商家配置区
   ----------------------------------------------------------------
   · price   : 展示售价（美元）
   · variantId : 对应 Shopify 产品变体 ID（后台商品页 URL 可见）。
     全部填好后，"Add to Cart" 会直接把整套设计加入店铺购物车；
     留空(null)则弹出设计清单弹窗（演示模式）。
   ================================================================ */
var CONFIG = {
  currency: "$",
  maxLayers: 3,
  maxCharmsPerLayer: 7,
  cartRedirect: "/cart",          // 加购成功后跳转
  variants: {}                    // 也可在此处集中覆盖，如 {chain_cable: 4477..., charm_heart: 4478...}
};

var CHAINS = [
  { id:"cable",     name:"Cable Chain",     price:32.90, variantId:null },
  { id:"paperclip", name:"Paperclip Chain", price:42.90, variantId:null },
  { id:"pearl",     name:"Pearl Strand",    price:46.90, variantId:null },
  { id:"snake",     name:"Snake Chain",     price:38.90, variantId:null },
  { id:"curb",      name:"Curb Chain",      price:36.90, variantId:null },
  { id:"satellite", name:"Satellite Chain", price:39.90, variantId:null }
];

var LENGTHS = [
  { id:"14", label:"14″", tag:"Choker",   drop:84  },
  { id:"16", label:"16″", tag:"Classic",  drop:132 },
  { id:"18", label:"18″", tag:"Layering", drop:180 },
  { id:"20", label:"20″", tag:"Long",     drop:228 }
];

var CHARMS = [
  { id:"heart",     name:"Heart",      price:16.90, variantId:null },
  { id:"letter",    name:"Initial",    price:18.90, variantId:null },
  { id:"pearl",     name:"Pearl Drop", price:14.90, variantId:null },
  { id:"star",      name:"Star",       price:15.90, variantId:null },
  { id:"moon",      name:"Moon",       price:15.90, variantId:null },
  { id:"butterfly", name:"Butterfly",  price:19.90, variantId:null },
  { id:"shell",     name:"Shell",      price:17.90, variantId:null },
  { id:"medallion", name:"Sun Coin",   price:22.90, variantId:null },
  { id:"bow",       name:"Bow",        price:18.90, variantId:null },
  { id:"eye",       name:"Evil Eye",   price:20.90, variantId:null },
  { id:"bolt",      name:"Bolt",       price:14.90, variantId:null },
  { id:"daisy",     name:"Daisy",      price:16.90, variantId:null }
];

/* ================================================================ */

var svgNS = "http://www.w3.org/2000/svg";
var NECK = { lx:218, rx:342, y:92, cx:280 };

var state = {
  layers: [ { chain:"cable", len:"16", charms:[] } ],
  active: 0,
  tab: "chain",
  view: "model",
  selected: null,
  letterMode: false
};
var uidSeq = 1, hintShown = false, chainHinted = false;

/* ---------- helpers ---------- */
function $(id){ return document.getElementById(id); }
function el(tag, attrs, parent){
  var n = document.createElementNS(svgNS, tag);
  for (var k in attrs) n.setAttribute(k, attrs[k]);
  if (parent) parent.appendChild(n);
  return n;
}
function money(v){ return CONFIG.currency + v.toFixed(2); }
function chainOf(l){ return CHAINS.filter(function(c){return c.id===l.chain;})[0]; }
function lenOf(l){ return LENGTHS.filter(function(x){return x.id===l.len;})[0]; }
function charmDef(id){ return CHARMS.filter(function(c){return c.id===id;})[0]; }
function esc(s){ return String(s).replace(/[&<>"]/g, function(c){ return {"&":"&amp;","<":"&lt;",">":"&gt;","\"":"&quot;"}[c]; }); }
function variantFor(kind, id){
  var o = kind==="chain" ? chainOf({chain:id}) : charmDef(id);
  return CONFIG.variants[kind+"_"+id] || (o && o.variantId) || null;
}

var toastTimer;
function toast(msg){
  var t = $("caToast");
  t.textContent = msg;
  t.classList.add("show");
  clearTimeout(toastTimer);
  toastTimer = setTimeout(function(){ t.classList.remove("show"); }, 2600);
}

/* ---------- geometry ---------- */
function pathD(drop){
  return "M "+NECK.lx+" "+NECK.y+" Q "+NECK.cx+" "+(NECK.y + 2*drop)+" "+NECK.rx+" "+NECK.y;
}
function samplePath(pathEl, n){
  var total = pathEl.getTotalLength(), pts = [];
  for (var i=0; i<=n; i++){
    var p = pathEl.getPointAtLength(total*i/n);
    pts.push({x:p.x, y:p.y, t:i/n});
  }
  return { pts:pts, total:total, el:pathEl };
}
function pointAt(sample, t){
  var p = sample.el.getPointAtLength(sample.total * t);
  var p2 = sample.el.getPointAtLength(Math.min(sample.total, sample.total*t + 1));
  return { x:p.x, y:p.y, ang: Math.atan2(p2.y-p.y, p2.x-p.x)*180/Math.PI };
}

/* ---------- chain link renderers ---------- */
function drawChainLinks(g, sample, styleId){
  var total = sample.total, i, l, p, p2, ang;
  function tangentAt(l){
    var a = sample.el.getPointAtLength(Math.max(0,l-0.8));
    var b = sample.el.getPointAtLength(Math.min(total,l+0.8));
    return Math.atan2(b.y-a.y, b.x-a.x)*180/Math.PI;
  }
  if (styleId === "cable"){
    for (l=0; l<=total; l+=6.2){
      p = sample.el.getPointAtLength(l);
      el("circle",{cx:p.x,cy:p.y,r:1.8,fill:"none",stroke:"url(#caSilverV)","stroke-width":1.25},g);
    }
  } else if (styleId === "curb"){
    for (l=0; l<=total; l+=4.6){
      p = sample.el.getPointAtLength(l); ang = tangentAt(l);
      el("ellipse",{cx:p.x,cy:p.y,rx:3,ry:2,fill:"none",stroke:"url(#caSilverV)","stroke-width":1.6,
        transform:"rotate("+ang+" "+p.x+" "+p.y+")"},g);
    }
  } else if (styleId === "paperclip"){
    for (l=1; l<total-6; l+=13.4){
      p = sample.el.getPointAtLength(l+5); ang = tangentAt(l+5);
      el("rect",{x:p.x-6,y:p.y-2.3,width:12,height:4.6,rx:2.3,fill:"none",stroke:"url(#caSilverV)","stroke-width":1.5,
        transform:"rotate("+ang+" "+p.x+" "+p.y+")"},g);
    }
  } else if (styleId === "pearl"){
    for (l=0; l<=total; l+=9.4){
      p = sample.el.getPointAtLength(l);
      el("circle",{cx:p.x,cy:p.y,r:4.5,fill:"url(#caPearl)",stroke:"rgba(150,140,120,.35)","stroke-width":.5},g);
      el("circle",{cx:p.x-1.4,cy:p.y-1.6,r:1.1,fill:"rgba(255,255,255,.9)"},g);
    }
  } else if (styleId === "snake"){
    el("path",{d:sample.el.getAttribute("d"),fill:"none",stroke:"url(#caSilverV)","stroke-width":3.4,"stroke-linecap":"round"},g);
    el("path",{d:sample.el.getAttribute("d"),fill:"none",stroke:"rgba(255,255,255,.75)","stroke-width":1,"stroke-dasharray":"1 2.6","stroke-linecap":"round"},g);
  } else if (styleId === "satellite"){
    el("path",{d:sample.el.getAttribute("d"),fill:"none",stroke:"url(#caSilverV)","stroke-width":1.1},g);
    for (l=9; l<total-4; l+=26){
      p = sample.el.getPointAtLength(l);
      el("circle",{cx:p.x,cy:p.y,r:2.6,fill:"url(#caSilver)",stroke:"rgba(120,120,130,.4)","stroke-width":.5},g);
    }
  }
}
/* small preview segment for chain cards */
function chainThumb(styleId){
  var s='<svg viewBox="0 0 120 26" xmlns="http://www.w3.org/2000/svg"><path id="tp" d="M4 13 Q 60 20 116 13" fill="none" stroke="none"/>';
  var pts=[], i;
  for(i=0;i<=28;i++){ var t=i/28, x=4+112*t, y=13+7*(4*t*(1-t)); pts.push([x,y]); }
  function tang(i){ var a=pts[Math.max(0,i-1)], b=pts[Math.min(pts.length-1,i+1)]; return Math.atan2(b[1]-a[1],b[0]-a[0])*180/Math.PI; }
  if(styleId==="cable"){ for(i=0;i<=28;i+=1){ if(i%1===0) s+='<circle cx="'+pts[i][0]+'" cy="'+pts[i][1]+'" r="1.7" fill="none" stroke="url(#caSilverV)" stroke-width="1.1"/>'; } }
  else if(styleId==="curb"){ for(i=0;i<=28;i++){ s+='<ellipse cx="'+pts[i][0]+'" cy="'+pts[i][1]+'" rx="2.8" ry="1.9" fill="none" stroke="url(#caSilverV)" stroke-width="1.4" transform="rotate('+tang(i)+' '+pts[i][0]+' '+pts[i][1]+')"/>'; } }
  else if(styleId==="paperclip"){ for(i=1;i<28;i+=3){ s+='<rect x="'+(pts[i][0]-5.5)+'" y="'+(pts[i][1]-2.2)+'" width="11" height="4.4" rx="2.2" fill="none" stroke="url(#caSilverV)" stroke-width="1.3" transform="rotate('+tang(i)+' '+pts[i][0]+' '+pts[i][1]+')"/>'; } }
  else if(styleId==="pearl"){ for(i=0;i<=28;i+=2){ s+='<circle cx="'+pts[i][0]+'" cy="'+pts[i][1]+'" r="3.8" fill="url(#caPearl)" stroke="rgba(150,140,120,.35)" stroke-width=".5"/>'; } }
  else if(styleId==="snake"){ s+='<path d="M4 13 Q 60 27 116 13" fill="none" stroke="url(#caSilverV)" stroke-width="3.2" stroke-linecap="round"/><path d="M4 13 Q 60 27 116 13" fill="none" stroke="rgba(255,255,255,.75)" stroke-width="1" stroke-dasharray="1 2.6"/>'; }
  else if(styleId==="satellite"){ s+='<path d="M4 13 Q 60 27 116 13" fill="none" stroke="url(#caSilverV)" stroke-width="1"/>'; for(i=2;i<=26;i+=6){ s+='<circle cx="'+pts[i][0]+'" cy="'+pts[i][1]+'" r="2.4" fill="url(#caSilver)"/>'; } }
  return s+"</svg>";
}

/* ---------- charm artwork (attach point at 0,0; hangs below) ----------
   吊饰绘制：默认使用内置 SVG。若某个吊饰在 CHARMS 里配置了 img 字段
   （建议 300×300 透明底 PNG 商品图），则自动改用实拍图渲染。 */
function charmArt(id, letter){
  var def = charmDef(id);
  var ring = '<circle cx="0" cy="3" r="2.6" fill="none" stroke="url(#caSilverV)" stroke-width="1.3"/>';
  if (def && def.img){
    return ring + '<image href="'+esc(def.img)+'" x="-17" y="6" width="34" height="36" preserveAspectRatio="xMidYMid meet"/>';
  }
  var A = { fill:'url(#caSilver)', edge:'rgba(110,110,120,.45)' };
  var body = "";
  switch(id){
    case "heart":
      body = '<path d="M0 15.5 C -2.6 10.5, -11.5 9.5, -13.4 17 C -14.8 23, -7.5 29.5, 0 35.5 C 7.5 29.5, 14.8 23, 13.4 17 C 11.5 9.5, 2.6 10.5, 0 15.5 Z" fill="'+A.fill+'" stroke="'+A.edge+'" stroke-width=".6"/>'
           + '<ellipse cx="-5.5" cy="16.5" rx="3" ry="1.8" fill="rgba(255,255,255,.65)" transform="rotate(-28 -5.5 16.5)"/>';
      break;
    case "star":
      body = '<path d="M0 12.6 L3.05 20.9 11.9 21.2 4.9 26.6 7.4 35.1 0 30.1 -7.4 35.1 -4.9 26.6 -11.9 21.2 -3.05 20.9 Z" fill="'+A.fill+'" stroke="'+A.fill+'" stroke-width="3" stroke-linejoin="round"/>'
           + '<ellipse cx="-2.4" cy="20" rx="2.2" ry="1.3" fill="rgba(255,255,255,.6)" transform="rotate(-30 -2.4 20)"/>';
      break;
    case "moon":
      body = '<path d="M 7 11 C -6 11 -13 18 -13 26 C -13 34 -6 41 7 41 C 0 37 -3.5 32 -3.5 26 C -3.5 20 0 15 7 11 Z" fill="'+A.fill+'" stroke="'+A.edge+'" stroke-width=".6" stroke-linejoin="round"/>';
      break;
    case "pearl":
      body = '<circle cx="0" cy="8" r="1.8" fill="none" stroke="url(#caSilverV)" stroke-width="1"/>'
           + '<circle cx="0" cy="20" r="9" fill="url(#caPearl)" stroke="rgba(150,140,120,.4)" stroke-width=".5"/>'
           + '<circle cx="-3" cy="16.5" r="2.2" fill="rgba(255,255,255,.9)"/>';
      break;
    case "butterfly":
      body = '<ellipse cx="-6.8" cy="18.5" rx="6.4" ry="8" fill="'+A.fill+'" stroke="'+A.edge+'" stroke-width=".5" transform="rotate(32 -6.8 18.5)"/>'
           + '<ellipse cx="6.8" cy="18.5" rx="6.4" ry="8" fill="'+A.fill+'" stroke="'+A.edge+'" stroke-width=".5" transform="rotate(-32 6.8 18.5)"/>'
           + '<ellipse cx="-5.4" cy="30" rx="4.4" ry="5.6" fill="'+A.fill+'" stroke="'+A.edge+'" stroke-width=".5" transform="rotate(-18 -5.4 30)"/>'
           + '<ellipse cx="5.4" cy="30" rx="4.4" ry="5.6" fill="'+A.fill+'" stroke="'+A.edge+'" stroke-width=".5" transform="rotate(18 5.4 30)"/>'
           + '<rect x="-1.4" y="12" width="2.8" height="22" rx="1.4" fill="url(#caSilverV)"/>';
      break;
    case "shell":
      body = '<path d="M 0 11 C -4 11 -9 14 -11 19 C -13 24 -13 29 -12 33 Q -8 39 -4 37.5 Q 0 41 4 37.5 Q 8 39 12 33 C 13 29 13 24 11 19 C 9 14 4 11 0 11 Z" fill="'+A.fill+'" stroke="'+A.edge+'" stroke-width=".6" stroke-linejoin="round"/>'
           + '<path d="M 0 13 L -8 34 M 0 13 L 0 38 M 0 13 L 8 34" stroke="rgba(110,110,120,.5)" stroke-width=".8" fill="none"/>';
      break;
    case "medallion":
      body = '<circle cx="0" cy="24" r="12.5" fill="'+A.fill+'" stroke="'+A.edge+'" stroke-width=".6"/>'
           + '<circle cx="0" cy="24" r="8.3" fill="none" stroke="rgba(110,110,120,.55)" stroke-width=".7"/>'
           + '<g stroke="rgba(110,110,120,.55)" stroke-width=".9">'
           + '<path d="M0 13.5 v3.4 M0 31.1 v3.4 M-10.5 24 h3.4 M7.1 24 h3.4 M-7.4 16.6 l2.4 2.4 M5 29 l2.4 2.4 M7.4 16.6 l-2.4 2.4 M-5 29 l-2.4 2.4"/></g>'
           + '<circle cx="0" cy="24" r="2.6" fill="rgba(110,110,120,.55)"/>';
      break;
    case "bow":
      body = '<path d="M -1.5 18 C -9 11, -17 13.5, -15.5 20 C -14.2 25.5, -6 24.5, -1.5 21.5 Z" fill="'+A.fill+'" stroke="'+A.edge+'" stroke-width=".5"/>'
           + '<path d="M 1.5 18 C 9 11, 17 13.5, 15.5 20 C 14.2 25.5, 6 24.5, 1.5 21.5 Z" fill="'+A.fill+'" stroke="'+A.edge+'" stroke-width=".5"/>'
           + '<path d="M -2 22 C -6.5 27, -8 32, -6 36 L -2.8 33 Z" fill="'+A.fill+'" stroke="'+A.edge+'" stroke-width=".5"/>'
           + '<path d="M 2 22 C 6.5 27, 8 32, 6 36 L 2.8 33 Z" fill="'+A.fill+'" stroke="'+A.edge+'" stroke-width=".5"/>'
           + '<circle cx="0" cy="19.5" r="3.4" fill="url(#caSilverV)" stroke="'+A.edge+'" stroke-width=".5"/>';
      break;
    case "eye":
      body = '<path d="M -14 23 Q 0 11 14 23 Q 0 35 -14 23 Z" fill="'+A.fill+'" stroke="'+A.edge+'" stroke-width=".6"/>'
           + '<circle cx="0" cy="23" r="5.6" fill="url(#caIris)"/>'
           + '<circle cx="0" cy="23" r="2.3" fill="#222"/>'
           + '<circle cx="-1.7" cy="21.2" r="1.1" fill="rgba(255,255,255,.95)"/>';
      break;
    case "bolt":
      body = '<path d="M 3.5 9 L -8.5 27 L -1.5 27 L -4 41 L 8.5 22 L 1.5 22 Z" fill="'+A.fill+'" stroke="'+A.edge+'" stroke-width=".6" stroke-linejoin="round"/>';
      break;
    case "daisy":
      var petals="", k;
      for (k=0;k<6;k++){
        var a=k*60, rad=a*Math.PI/180, px=Math.sin(rad)*7.6, py=24-Math.cos(rad)*7.6;
        petals += '<ellipse cx="'+px.toFixed(1)+'" cy="'+py.toFixed(1)+'" rx="3.5" ry="7.2" fill="url(#caPearl)" stroke="rgba(150,140,120,.35)" stroke-width=".4" transform="rotate('+a+' '+px.toFixed(1)+' '+py.toFixed(1)+')"/>';
      }
      body = petals + '<circle cx="0" cy="24" r="3.9" fill="url(#caSilver)" stroke="rgba(110,110,120,.45)" stroke-width=".5"/>';
      break;
    case "letter":
      body = '<circle cx="0" cy="23" r="11.8" fill="'+A.fill+'" stroke="'+A.edge+'" stroke-width=".6"/>'
           + '<circle cx="0" cy="23" r="9.2" fill="none" stroke="rgba(110,110,120,.4)" stroke-width=".6"/>'
           + '<text x="0" y="23" text-anchor="middle" dominant-baseline="central" font-family="Libre Baskerville, Georgia, serif" font-size="11.5" fill="#71717a">'+esc(letter||"A")+'</text>';
      break;
  }
  return ring + body;
}
function charmThumb(id, letter){
  return '<svg viewBox="-22 -2 44 44" xmlns="http://www.w3.org/2000/svg" transform="scale(1)"><g transform="translate(0,-4) scale(.92)">'+charmArt(id,letter)+'</g></svg>';
}

/* ---------- bust line art ---------- */
function drawBust(root){
  var g = el("g",{id:"caBust",fill:"none",stroke:"#ddd6cc","stroke-width":1.4,"stroke-linecap":"round",opacity: state.view==="model"?1:0},root);
  el("path",{d:"M226 0 C 227 38 222 66 208 86 C 190 110 148 124 94 142 C 56 154 32 174 22 204"},g);
  el("path",{d:"M334 0 C 333 38 338 66 352 86 C 370 110 412 124 466 142 C 504 154 528 174 538 204"},g);
  el("path",{d:"M206 146 C 234 138 256 124 264 110",stroke:"#e7e1d7","stroke-width":1.1},g);
  el("path",{d:"M354 146 C 326 138 304 124 296 110",stroke:"#e7e1d7","stroke-width":1.1},g);
}

/* ---------- main render ---------- */
var layerSamples = [];

function renderPreview(){
  var svg = $("caSvg");
  svg.innerHTML = "";
  var maxDrop = Math.max.apply(null, state.layers.map(function(l){ return lenOf(l).drop; }));
  svg.setAttribute("viewBox", "0 0 560 " + Math.max(330, NECK.y + maxDrop + 96));
  drawBust(svg);
  layerSamples = [];

  var sorted = state.layers.map(function(l,i){ return {l:l, i:i}; })
    .sort(function(a,b){ return lenOf(a.l).drop - lenOf(b.l).drop; });

  sorted.forEach(function(o){
    var layer = o.l, idx = o.i;
    var drop = lenOf(layer).drop;
    var lg = el("g",{"class":"ca-layer","data-layer":idx},svg);
    var isActive = idx === state.active;

    var geo = el("path",{d:pathD(drop),fill:"none",stroke:"none"},lg);
    var sample = samplePath(geo, 140);
    layerSamples[idx] = sample;

    // soft halo under the chain being edited
    if (isActive && state.layers.length > 1){
      el("path",{d:pathD(drop),fill:"none",stroke:"#e6dcc6",opacity:.55,"stroke-width":11,
        "stroke-linecap":"round",filter:"url(#caGlow)"},lg);
    }

    // wide invisible hit path — click to activate layer
    el("path",{d:pathD(drop),fill:"none",stroke:"rgba(0,0,0,0)","stroke-width":18,"class":"ca-chain-hit","data-layer":idx},lg);

    var linksG = el("g",{},lg);
    drawChainLinks(linksG, sample, layer.chain);

    // charms sorted by t so left→right stacking is natural
    layer.charms.slice().sort(function(a,b){return a.t-b.t;}).forEach(function(ch){
      var p = pointAt(sample, ch.t);
      var g = el("g",{"class":"ca-charm"+(ch.uid===state.selected?" selected":"")+(ch.justAdded?" just-added":""),
        transform:"translate("+p.x.toFixed(1)+","+p.y.toFixed(1)+")","data-uid":ch.uid,"data-layer":idx},lg);
      // generous invisible hit area
      el("rect",{x:-20,y:-10,width:40,height:56,fill:"rgba(0,0,0,0)"},g);
      var gScale = el("g",{transform:"scale(0.84)"},g);
      var sway = el("g",{"class":"sway"},gScale);
      sway.innerHTML = charmArt(ch.id, ch.letter);
      if (ch.uid === state.selected){
        el("circle",{cx:0,cy:19,r:21,fill:"none",stroke:"#c9c2b6","stroke-width":1,"stroke-dasharray":"2.5 4",opacity:.9},g);
        var rm = el("g",{"class":"ca-rm",transform:"translate(16,-4)",cursor:"pointer","data-rm":ch.uid},g);
        el("circle",{cx:0,cy:0,r:8.5,fill:"#222"},rm);
        el("path",{d:"M-3 -3 L3 3 M3 -3 L-3 3",stroke:"#fff","stroke-width":1.3,"stroke-linecap":"round"},rm);
      }
      delete ch.justAdded;
    });
  });

  var hasCharms = state.layers.some(function(l){return l.charms.length;});
  $("caHint").style.opacity = hasCharms ? 0 : 1;
  syncStickyTabs();
}

/* keep the tab bar pinned right below the sticky preview on mobile */
function syncStickyTabs(){
  var stage = document.querySelector("#charm-atelier .ca-stage");
  var root = $("charm-atelier");
  if (stage && root){
    root.style.setProperty("--ca-stage-h", (Math.ceil(stage.getBoundingClientRect().height) - 1) + "px");
  }
}
window.addEventListener("resize", syncStickyTabs);
window.addEventListener("load", function(){ syncStickyTabs(); setTimeout(syncStickyTabs, 300); });

function renderLayerbar(){
  var bar = $("caLayerbar");
  bar.innerHTML = "";
  state.layers.forEach(function(l, i){
    var chip = document.createElement("button");
    chip.type = "button";
    chip.className = "ca-layerchip" + (i===state.active ? " active" : "");
    chip.innerHTML = '<span class="dot"></span>'+esc(chainOf(l).name.replace(" Chain","").replace(" Strand",""))+' · '+lenOf(l).label
      + (state.layers.length>1 ? '<span class="x" data-removelayer="'+i+'" title="Remove this chain">×</span>' : '');
    chip.addEventListener("click", function(e){
      if (e.target.dataset.removelayer !== undefined){ removeLayer(i); return; }
      state.active = i; state.selected = null; renderAll();
    });
    bar.appendChild(chip);
  });
  if (state.layers.length < CONFIG.maxLayers){
    var add = document.createElement("button");
    add.type = "button";
    add.className = "ca-addlayer";
    add.innerHTML = '<span class="plus">+</span> Stack another chain';
    add.addEventListener("click", addLayer);
    bar.appendChild(add);
  }
}

function renderPanel(){
  var body = $("caPanelbody");
  var layer = state.layers[state.active];
  document.querySelectorAll(".ca-tab").forEach(function(t){
    t.classList.toggle("on", t.dataset.tab === state.tab);
  });

  if (state.tab === "chain"){
    var html = '<div class="ca-fadein">';
    html += '<div class="ca-sectionlabel">Chain style <em>for '+(state.layers.length>1?("chain "+(state.active+1)):"your necklace")+'</em></div>';
    html += '<div class="ca-chaingrid">';
    CHAINS.forEach(function(c){
      html += '<button type="button" class="ca-chaincard'+(layer.chain===c.id?" on":"")+'" data-chain="'+c.id+'">'
            + chainThumb(c.id)
            + '<div class="nm">'+esc(c.name)+'</div><div class="pr">'+money(c.price)+'</div></button>';
    });
    html += '</div>';
    html += '<div class="ca-sectionlabel">Length</div><div class="ca-lengths">';
    LENGTHS.forEach(function(L){
      var taken = state.layers.some(function(l,i){ return i!==state.active && l.len===L.id; });
      html += '<button type="button" class="ca-len'+(layer.len===L.id?" on":"")+'" data-len="'+L.id+'" '
            + (taken?'disabled title="Already in your stack"':'')+'>'+L.label+'<small>'+L.tag+'</small></button>';
    });
    html += '</div></div>';
    body.innerHTML = html;

    body.querySelectorAll("[data-chain]").forEach(function(b){
      b.addEventListener("click", function(){
        layer.chain = b.dataset.chain;
        renderAll();
        if (!chainHinted){ chainHinted = true; setTimeout(function(){ setTab("charms"); toast("Now add your charms ✦"); }, 550); }
      });
    });
    body.querySelectorAll("[data-len]").forEach(function(b){
      b.addEventListener("click", function(){ layer.len = b.dataset.len; renderAll(); });
    });

  } else if (state.letterMode){
    var html2 = '<div class="ca-fadein"><button type="button" class="ca-letterback" id="caLetterBack">← Back to charms</button>'
              + '<div class="ca-sectionlabel">Choose your initial</div><div class="ca-lettergrid">';
    "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("").forEach(function(ch){
      html2 += '<button type="button" class="ca-letter" data-letter="'+ch+'">'+ch+'</button>';
    });
    html2 += '</div></div>';
    body.innerHTML = html2;
    $("caLetterBack").addEventListener("click", function(){ state.letterMode=false; renderPanel(); });
    body.querySelectorAll("[data-letter]").forEach(function(b){
      b.addEventListener("click", function(){
        state.letterMode = false;
        addCharm("letter", b.dataset.letter);
        renderPanel();
      });
    });

  } else {
    var count = layer.charms.length;
    var html3 = '<div class="ca-fadein">';
    html3 += '<div class="ca-sectionlabel">Charms <em>'+count+' / '+CONFIG.maxCharmsPerLayer
           + (state.layers.length>1 ? (' on chain '+(state.active+1)) : '')+'</em></div>';
    html3 += '<div class="ca-charmgrid">';
    CHARMS.forEach(function(c){
      html3 += '<button type="button" class="ca-charmcard" data-charm="'+c.id+'">'
             + '<span class="add">+</span>' + charmThumb(c.id)
             + '<div class="nm">'+esc(c.name)+'</div><div class="pr">'+money(c.price)+'</div></button>';
    });
    html3 += '</div></div>';
    body.innerHTML = html3;
    body.querySelectorAll("[data-charm]").forEach(function(b){
      b.addEventListener("click", function(){
        if (b.dataset.charm === "letter"){ state.letterMode = true; renderPanel(); return; }
        addCharm(b.dataset.charm);
      });
    });
  }
}

function renderBar(){
  var total = 0, items = 0;
  state.layers.forEach(function(l){
    total += chainOf(l).price; items++;
    l.charms.forEach(function(c){ total += charmDef(c.id).price; items++; });
  });
  $("caTotal").textContent = money(total);
  $("caCta").textContent = "Add to Cart — " + money(total);

  var d = $("caDetailIn"), html = "";
  state.layers.forEach(function(l, i){
    html += '<div class="ca-ditem"><span>'+esc(chainOf(l).name)+' · '+lenOf(l).label+'</span><span class="dp">'+money(chainOf(l).price)+'</span></div>';
    l.charms.slice().sort(function(a,b){return a.t-b.t;}).forEach(function(c){
      var def = charmDef(c.id);
      html += '<div class="ca-ditem sub"><span>'+esc(def.name)+(c.letter?' “'+esc(c.letter)+'”':'')
            + '</span><span class="dp">'+money(def.price)+'<button type="button" class="rm" data-rmitem="'+c.uid+'" aria-label="Remove">×</button></span></div>';
    });
  });
  d.innerHTML = html;
  d.querySelectorAll("[data-rmitem]").forEach(function(b){
    b.addEventListener("click", function(){ removeCharm(+b.dataset.rmitem); });
  });
}

function renderAll(){
  renderLayerbar();
  renderPreview();
  renderPanel();
  renderBar();
  saveHash();
}
function setTab(t){ state.tab = t; state.letterMode = false; renderPanel(); }

/* ---------- actions ---------- */
function addCharm(id, letter){
  var layer = state.layers[state.active];
  if (layer.charms.length >= CONFIG.maxCharmsPerLayer){
    toast("Up to "+CONFIG.maxCharmsPerLayer+" charms per chain"); return;
  }
  var spots = [.5,.34,.66,.2,.8,.1,.9], t = null;
  for (var i=0;i<spots.length;i++){
    var free = layer.charms.every(function(c){ return Math.abs(c.t - spots[i]) > .1; });
    if (free){ t = spots[i]; break; }
  }
  if (t === null) t = .5 + (Math.random()-.5)*.5;
  var uid = uidSeq++;
  layer.charms.push({uid:uid, id:id, t:t, letter:letter, justAdded:true});
  state.selected = uid;
  renderAll();
  if (!hintShown){ hintShown = true; toast("Drag the charm along the chain to arrange"); }
}
function removeCharm(uid){
  state.layers.forEach(function(l){
    l.charms = l.charms.filter(function(c){ return c.uid !== uid; });
  });
  if (state.selected === uid) state.selected = null;
  renderAll();
}
function addLayer(){
  if (state.layers.length >= CONFIG.maxLayers) return;
  var usedLens = state.layers.map(function(l){return l.len;});
  var free = LENGTHS.filter(function(L){ return usedLens.indexOf(L.id)<0; });
  var maxUsed = Math.max.apply(null, state.layers.map(function(l){ return lenOf(l).drop; }));
  var longer = free.filter(function(L){ return L.drop > maxUsed; });
  state.layers.push({ chain:"cable", len:((longer[0]||free[0])||LENGTHS[0]).id, charms:[] });
  state.active = state.layers.length - 1;
  state.tab = "chain"; state.selected = null;
  renderAll();
  toast("Chain "+state.layers.length+" added — choose its style");
}
function removeLayer(i){
  state.layers.splice(i,1);
  if (state.active >= state.layers.length) state.active = state.layers.length-1;
  state.selected = null;
  renderAll();
  toast("Chain removed");
}

/* ---------- drag ---------- */
var drag = null;
function svgPoint(evt){
  var svg = $("caSvg"), pt = svg.createSVGPoint();
  pt.x = evt.clientX; pt.y = evt.clientY;
  return pt.matrixTransform(svg.getScreenCTM().inverse());
}
function nearestT(sample, x, y){
  var best = 0, bd = 1e9;
  for (var i=0;i<sample.pts.length;i++){
    var dx = sample.pts[i].x - x, dy = sample.pts[i].y - y, d = dx*dx + dy*dy;
    if (d < bd){ bd = d; best = i; }
  }
  return Math.min(.92, Math.max(.08, sample.pts[best].t));
}
function findCharm(uid){
  for (var i=0;i<state.layers.length;i++){
    var c = state.layers[i].charms.filter(function(c){return c.uid===uid;})[0];
    if (c) return {layer:i, charm:c};
  }
  return null;
}

$("caSvg").addEventListener("pointerdown", function(e){
  var rmEl = e.target.closest("[data-rm]");
  if (rmEl){ removeCharm(+rmEl.dataset.rm); e.stopPropagation(); return; }
  var g = e.target.closest(".ca-charm");
  if (g){
    var uid = +g.dataset.uid, found = findCharm(uid);
    if (!found) return;
    state.active = found.layer;
    if (state.selected !== uid){ state.selected = uid; renderAll(); }
    g = $("caSvg").querySelector('.ca-charm[data-uid="'+uid+'"]');
    drag = { uid:uid, layer:found.layer, charm:found.charm, g:g, moved:false };
    g.classList.add("dragging");
    try { $("caSvg").setPointerCapture(e.pointerId); } catch(err){}
    e.preventDefault();
    return;
  }
  var hit = e.target.closest(".ca-chain-hit");
  if (hit){
    var li = +hit.dataset.layer;
    if (li !== state.active){ state.active = li; state.selected = null; renderAll(); }
    return;
  }
  if (state.selected !== null){ state.selected = null; renderAll(); }
});
$("caSvg").addEventListener("pointermove", function(e){
  if (!drag) return;
  var p = svgPoint(e);
  var sample = layerSamples[drag.layer];
  if (!sample) return;
  var t = nearestT(sample, p.x, p.y);
  drag.charm.t = t;
  drag.moved = true;
  var pos = pointAt(sample, t);
  drag.g.setAttribute("transform", "translate("+pos.x.toFixed(1)+","+pos.y.toFixed(1)+")");
  e.preventDefault();
});
function endDrag(){
  if (!drag) return;
  drag.g.classList.remove("dragging");
  var moved = drag.moved;
  drag = null;
  if (moved) renderAll(); else { renderBar(); saveHash(); }
}
$("caSvg").addEventListener("pointerup", endDrag);
$("caSvg").addEventListener("pointercancel", endDrag);

document.addEventListener("keydown", function(e){
  if ((e.key === "Delete" || e.key === "Backspace") && state.selected !== null){
    var tag = document.activeElement && document.activeElement.tagName;
    if (tag === "INPUT" || tag === "TEXTAREA") return;
    removeCharm(state.selected);
    e.preventDefault();
  }
});

/* ---------- view toggle ---------- */
$("caViewModel").addEventListener("click", function(){ setView("model"); });
$("caViewPlain").addEventListener("click", function(){ setView("plain"); });
function setView(v){
  state.view = v;
  $("caViewModel").classList.toggle("on", v==="model");
  $("caViewPlain").classList.toggle("on", v==="plain");
  var b = $("caSvg").querySelector("#caBust");
  if (b) b.setAttribute("opacity", v==="model" ? 1 : 0);
}

/* ---------- tabs / detail ---------- */
document.querySelectorAll(".ca-tab").forEach(function(t){
  t.addEventListener("click", function(){ setTab(t.dataset.tab); });
});
$("caDetailToggle").addEventListener("click", function(){
  $("caDetail").classList.toggle("open");
});

/* ---------- share / reset ---------- */
function serialize(){
  return { v:1, a:state.active, L:state.layers.map(function(l){
    return { c:l.chain, n:l.len, h:l.charms.map(function(c){ return [c.id, Math.round(c.t*1000)/1000, c.letter||""]; }) };
  })};
}
function saveHash(){
  try{
    var code = btoa(unescape(encodeURIComponent(JSON.stringify(serialize())))).replace(/=+$/,"");
    history.replaceState(null, "", "#d=" + code);
  }catch(e){}
}
function loadHash(){
  try{
    var m = location.hash.match(/#d=([A-Za-z0-9+/]+)/);
    if (!m) return false;
    var data = JSON.parse(decodeURIComponent(escape(atob(m[1]))));
    if (!data || !data.L || !data.L.length) return false;
    state.layers = data.L.slice(0, CONFIG.maxLayers).map(function(l){
      return {
        chain: chainOf({chain:l.c}) ? l.c : CHAINS[0].id,
        len: lenOf({len:l.n}) ? l.n : LENGTHS[1].id,
        charms: (l.h||[]).slice(0, CONFIG.maxCharmsPerLayer).map(function(h){
          return { uid:uidSeq++, id: charmDef(h[0]) ? h[0] : CHARMS[0].id, t: Math.min(.92, Math.max(.08, +h[1]||.5)), letter: h[2]||undefined };
        })
      };
    });
    state.active = Math.min(data.a||0, state.layers.length-1);
    return true;
  }catch(e){ return false; }
}
$("caShare").addEventListener("click", function(){
  saveHash();
  var url = location.href;
  if (navigator.clipboard && navigator.clipboard.writeText){
    navigator.clipboard.writeText(url).then(function(){ toast("Design link copied ✦"); },
      function(){ openModal(true); });
  } else openModal(true);
});
$("caReset").addEventListener("click", function(){
  state.layers = [ { chain:"cable", len:"16", charms:[] } ];
  state.active = 0; state.selected = null; state.tab = "chain"; state.letterMode = false;
  history.replaceState(null, "", location.pathname + location.search);
  renderAll();
  toast("Fresh start");
});

/* ---------- cart ---------- */
function buildLineItems(){
  var items = [], missing = false;
  state.layers.forEach(function(l, i){
    var c = chainOf(l);
    var charmNames = l.charms.slice().sort(function(a,b){return a.t-b.t;}).map(function(ch, k){
      var def = charmDef(ch.id);
      return def.name + (ch.letter ? " “"+ch.letter+"”" : "") + " (pos "+(k+1)+"/"+l.charms.length+")";
    });
    var vid = variantFor("chain", l.chain);
    if (!vid) missing = true;
    items.push({ id: vid, quantity: 1, properties: {
      "_Design": "Chain "+(i+1)+" of "+state.layers.length,
      "Length": lenOf(l).label + " " + lenOf(l).tag,
      "Charms": charmNames.length ? charmNames.join(", ") : "None",
      "Design link": location.href
    }});
    var counts = {};
    l.charms.forEach(function(ch){
      var key = ch.id + (ch.letter||"");
      counts[key] = counts[key] || { id:ch.id, letter:ch.letter, q:0 };
      counts[key].q++;
    });
    Object.keys(counts).forEach(function(k){
      var it = counts[k], cvid = variantFor("charm", it.id);
      if (!cvid) missing = true;
      items.push({ id: cvid, quantity: it.q, properties: {
        "_Design": "Charm on chain "+(i+1),
        "Initial": it.letter || undefined,
        "Design link": location.href
      }});
    });
  });
  return { items: items, missing: missing };
}
$("caCta").addEventListener("click", function(){
  var built = buildLineItems();
  var onShopify = typeof window.Shopify !== "undefined" || /myshopify|\/cart/.test(document.location.hostname + document.location.pathname);
  if (!built.missing && onShopify){
    var btn = $("caCta");
    btn.disabled = true; btn.textContent = "Adding…";
    fetch("/cart/add.js", {
      method:"POST", headers:{ "Content-Type":"application/json" },
      body: JSON.stringify({ items: built.items })
    }).then(function(r){
      if (!r.ok) throw new Error("cart");
      window.location.href = CONFIG.cartRedirect;
    }).catch(function(){
      btn.disabled = false; renderBar();
      openModal(false);
    });
  } else {
    openModal(false);
  }
});

/* ---------- modal ---------- */
function openModal(shareOnly){
  saveHash();
  var total = 0, html = "";
  state.layers.forEach(function(l, i){
    var c = chainOf(l);
    total += c.price;
    html += '<div class="ca-ditem"><span>'+esc(c.name)+' · '+lenOf(l).label+' '+lenOf(l).tag+'</span><span class="dp">'+money(c.price)+'</span></div>';
    l.charms.slice().sort(function(a,b){return a.t-b.t;}).forEach(function(ch, k){
      var def = charmDef(ch.id);
      total += def.price;
      html += '<div class="ca-ditem sub"><span>'+esc(def.name)+(ch.letter?' “'+esc(ch.letter)+'”':'')+' — position '+(k+1)+'</span><span class="dp">'+money(def.price)+'</span></div>';
    });
  });
  $("caModalList").innerHTML = html;
  $("caModalTotal").textContent = money(total);
  $("caModalSub").textContent = shareOnly ? "Copy the link below to share or save your design." : "Here's everything in your custom stack.";
  $("caShareUrl").value = location.href;
  $("caModalWrap").classList.add("open");
  $("caModalWrap").setAttribute("aria-hidden","false");
}
function closeModal(){
  $("caModalWrap").classList.remove("open");
  $("caModalWrap").setAttribute("aria-hidden","true");
}
$("caModalClose").addEventListener("click", closeModal);
$("caModalWrap").addEventListener("click", function(e){ if (e.target === $("caModalWrap")) closeModal(); });
$("caCopyUrl").addEventListener("click", function(){
  var inp = $("caShareUrl");
  inp.select(); inp.setSelectionRange(0, 9999);
  if (navigator.clipboard && navigator.clipboard.writeText){
    navigator.clipboard.writeText(inp.value).then(function(){ toast("Copied ✦"); });
  } else { document.execCommand("copy"); toast("Copied ✦"); }
});
document.addEventListener("keydown", function(e){ if (e.key === "Escape") closeModal(); });

/* ---------- init ---------- */
if (loadHash()){
  state.tab = "charms";
  chainHinted = true; hintShown = true;
}
renderAll();

})();
